/**
 * Имя релиза для карточки: только цифры (после trim) — крупная типографика.
 * Любые буквы, пробелы внутри, знаки — режим обычного заголовка.
 */
export function releaseTitleIsNumericOnly(name: string | null | undefined): boolean {
  if (name == null) return false;
  return /^\d+$/.test(name.trim());
}

export function releaseTitleTrimmed(name: string | null | undefined): string {
  return (name ?? "").trim();
}
